// src/components/blog/BlogAuthorBio.jsx

import React, { memo } from 'react';
import { getAuthorInitials } from '../../utils/blogUtils';

const BlogAuthorBio = memo(({ author, isDark }) => {
  if (!author) return null;

  return (
    <div className={`mt-12 p-6 rounded-2xl ${
      isDark 
        ? 'bg-white/5 border border-white/10' 
        : 'bg-gray-50 border border-gray-200'
    }`}>
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          {author.avatar ? (
            <img 
              src={author.avatar} 
              alt={author.name} 
              className="w-16 h-16 rounded-full object-cover"
            />
          ) : (
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-blue-700 to-blue-900 flex items-center justify-center text-white text-xl font-bold">
              {getAuthorInitials(author.name)}
            </div>
          )}
        </div>

        <div className="flex-1">
          <h3 className={`text-lg font-bold mb-1 ${
            isDark ? 'text-white' : 'text-gray-900'
          }`}>
            {author.name}
          </h3>

          {author.role && (
            <p className={`text-sm mb-2 ${
              isDark ? 'text-blue-400' : 'text-blue-700'
            }`}>
              {author.role}
            </p>
          )}

          {author.bio && (
            <p className={`text-sm ${
              isDark ? 'text-gray-400' : 'text-gray-600'
            }`}>
              {author.bio}
            </p>
          )}
        </div>
      </div>
    </div>
  );
});

BlogAuthorBio.displayName = 'BlogAuthorBio';

export default BlogAuthorBio;